export default (value, {format = 'HH:mm'}) => {
    return moment(value, format, true).isValid()
}
